import React from 'react';
import { Icon } from 'tea-component';

import * as styles from './tag.module.less';
import { TagProps } from '../type';
import SvgIcon from '../../../SvgIcon';

const Tag = (props: TagProps) => {
  const { id, name, onDelete = () => {} } = props;

  return (
    <div className={styles['tag-container']}>
      <span className={styles['tag-text']}>{name}</span>
      <span className={styles['tag-icon']} onClick={() => onDelete([id])}>
        <SvgIcon type="clonse" />
      </span>
    </div>
  );
};

export default Tag;
